import i18n, { LANGUAGE_STORAGE_KEY } from "../_i18n/i18n";

/** PL → EN for demo content (names, clubs, groups, exercises). Longest keys first. */
const DEMO_PL_TO_EN: Array<[string, string]> = [
  [
    "Zapraszamy na otwarty trening pokazowy w najbliższą sobotę o godz. 10:00. Prosimy o wcześniejsze zgłoszenie u trenera grupy.",
    "You are invited to an open showcase training this Saturday at 10:00. Please register in advance with the group coach.",
  ],
  [
    "Gratulacje dla zawodników U15A za wygrany sparing 3:1! Świetna gra zespołowa i pressing w drugiej połowie.",
    "Congratulations to the U15A players on the 3–1 friendly win! Great teamwork and pressing in the second half.",
  ],
  [
    "Przypominamy o terminie opłat za karnety — do 15 lipca. W razie pytań prosimy o kontakt z sekretariatem.",
    "Reminder: membership fee payments are due by July 15. If you have any questions, please contact the office.",
  ],
  [
    "Ruszyła rejestracja na obóz letni w Zakopanem (18–25 sierpnia). Liczba miejsc ograniczona — decyzja w kolejności zgłoszeń.",
    "Registration for the summer camp in Zakopane (August 18–25) is now open. Places are limited — first come, first served.",
  ],
  [
    "Grupa U13B: w środę trening techniczny na hali, proszę zabrać buty halowe i bidon. Zajęcia zaczynamy punktualnie o 17:00.",
    "U13B group: technical training in the indoor hall on Wednesday — please bring indoor shoes and a water bottle. Session starts promptly at 17:00.",
  ],
  [
    "U17: analiza wideo z ostatniego meczu ligowego będzie dostępna w folderze grupy do piątku. Zachęcam do samodzielnego omówienia akcji.",
    "U17: video analysis from the last league match will be available in the group folder by Friday. Please review the key actions on your own.",
  ],
  [
    "Dziękujemy za wsparcie na turnieju! Zawodnicy U15A wracają zmęczeni, ale bardzo zadowoleni z gry i atmosfery.",
    "Thank you for your support at the tournament! The U15A players are tired but very happy with the games and the atmosphere.",
  ],
  [
    "Witamy nowych zawodników w akademii! Pierwsze treningi adaptacyjne odbędą się w grupach według harmonogramu od poniedziałku.",
    "Welcome to the new players joining the academy! The first adaptation sessions will take place in groups according to the schedule from Monday.",
  ],
  [
    "Turniej międzyoddziałowy Demo Cup już 20 lipca. Zapraszamy kibiców — wstęp wolny, początek meczów finałowych o 15:00.",
    "The inter-branch Demo Cup tournament is on July 20. Fans are welcome — free entry, final matches start at 15:00.",
  ],
  [
    "Oddział Północ: zebranie rodziców grupy Trampkarz 2014 w poniedziałek o 18:00 w sali konferencyjnej.",
    "North Branch: parents' meeting for the 2014 Youth Team on Monday at 18:00 in the conference room.",
  ],
  [
    "Jutrzejszy trening U14 przeniesiony na boisko przy ul. Sportowej 8. Proszę o punktualne przyjście 15 minut wcześniej.",
    "Tomorrow's U14 training has been moved to the pitch at Sportowa 8. Please arrive 15 minutes early.",
  ],
  [
    "Południe: sparing kontrolny z lokalnym klubem w sobotę o 11:00. Lista zawodników zostanie wysłana do rodziców w czwartek.",
    "South: control friendly vs a local club on Saturday at 11:00. The player list will be sent to parents on Thursday.",
  ],
  [
    "Przypominamy o zamówieniu strojów treningowych — formularz w biurze akademii. Termin składania zamówień: 20 lipca.",
    "Reminder to order training kits — the form is available at the academy office. Order deadline: July 20.",
  ],
  ["Wzór umowy członkowskiej.pdf", "Membership agreement template.pdf"],
  ["Program obozu letniego.pdf", "Summer camp program.pdf"],
  ["Zasady bezpieczeństwa.pdf", "Safety rules.pdf"],
  ["Ćwiczenia techniczne.pdf", "Technical exercises.pdf"],
  ["Plan treningowy U15.pdf", "U15 training plan.pdf"],
  ["Regulamin akademii.pdf", "Academy regulations.pdf"],
  ["Czy zawodnik wymaga diety specjalnej?", "Does the player require a special diet?"],
  ["Preferowany dojazd na trening?", "Preferred transport to training?"],
  ["Rozmiar stroju treningowego?", "Training kit size?"],
  ["Czy zawodnik ma alergie?", "Does the player have any allergies?"],
  ["Regulamin oddziału Północ", "North branch regulations"],
  ["Regulamin oddziału Południe", "South branch regulations"],
  ["Zasady bezpieczeństwa", "Safety rules"],
  ["Regulamin akademii", "Academy regulations"],
  ["Materiały szkoleniowe online", "Online training materials"],
  ["Materiały szkoleniowe", "Training materials"],
  ["Zgoda RODO", "GDPR consent"],
  ["Regulaminy", "Regulations"],
  ["Umowy", "Contracts"],
  [
    "Koszulki, spodenki i akcesoria treningowe",
    "Training shirts, shorts and accessories",
  ],
  ["Piłki, bramki i sprzęt treningowy", "Balls, goals and training equipment"],
  ["Materiały wideo i szkolenia online", "Video materials and online courses"],
  ["Bidon z logo oddziału północ", "Water bottle with North branch logo"],
  ["Czapka oddziału południe", "South branch cap"],
  ["Koszulka treningowa demo", "Demo training shirt"],
  ["Piłka treningowa demo", "Demo training ball"],
  ["Pakiet wideo — technika", "Video pack — technique"],
  ["Koszulka treningowa", "Training shirt"],
  ["Piłka treningowa", "Training ball"],
  ["Czapka z daszkiem", "Baseball cap"],
  ["Bidon klubowy", "Club water bottle"],
  ["Specyfikacja produktu.pdf", "Product specification.pdf"],
  ["Instrukcja użytkowania.pdf", "User manual.pdf"],
  ["Potwierdzenie zamówienia.pdf", "Order confirmation.pdf"],
  ["Faktura VAT.pdf", "VAT invoice.pdf"],
  ["Dokument.pdf", "Document.pdf"],
  ["Rabat sezonowy 10%", "Seasonal discount 10%"],
  ["Promocja klubowa 15%", "Club promotion 15%"],
  ["produkt demo akademii", "academy demo product"],
  ["Dostępny w sklepie JustWin.", "Available in the JustWin store."],
  ["Odbiór w siedzibie akademii", "Pickup at the academy premises"],
  ["Dostawa cyfrowa / produkt elektroniczny", "Digital delivery / electronic product"],
  ["Dostawa do paczkomatu", "Delivery to parcel locker"],
  ["Obowiązujący regulamin dla zawodników i rodziców", "Applicable regulations for players and parents"],
  ["Zgoda na przetwarzanie danych osobowych", "Consent to personal data processing"],
  ["Zgoda na przetwarzanie danych", "Consent to data processing"],
  ["Badania okresowe", "Periodic tests"],
  ["Zasady zachowania na obiektach sportowych", "Safety rules at sports facilities"],
  ["Regulamin lokalny oddziału Warszawa", "Local regulations for Warsaw branch"],
  ["Regulamin lokalny oddziału Katowice", "Local regulations for Katowice branch"],
  ["Karnet miesięczny", "Monthly pass"],
  ["Karnet wakacyjny", "Holiday pass"],
  ["Odbiór osobisty", "In-person pickup"],
  ["Paczkomat InPost", "InPost parcel locker"],
  ["Kategoria:", "Category:"],
  ["Dokument", "Document"],
  ["Pytanie", "Question"],
  ["Odzież", "Apparel"],
  ["Sprzęt", "Equipment"],
  ["Cyfrowe", "Digital"],
  ["Rozmiar", "Size"],
  ["Kolor", "Color"],
  ["Materiał", "Material"],
  ["Biały", "White"],
  ["Czarny", "Black"],
  ["Niebieski", "Blue"],
  ["Bawełna", "Cotton"],
  ["Poliester", "Polyester"],
  ["Oddział Akademii - Zachodni", "Academy Branch - West"],
  ["Oddział Akademii — Zachodni", "Academy Branch - West"],
  ["Stadion Miejski, Bułgarska 17, 60-320 Poznań", "Municipal Stadium, 17 Bułgarska St., 60-320 Poznań"],
  ["U17, Pierwsza drużyna", "U17, First Team"],
  ["U17,Pierwsza drużyna", "U17,First Team"],
  ["Rezerwy,Pierwsza drużyna", "Reserves,First Team"],
  ["Trucht z piłką wokół boiska", "Jogging Around the Pitch with the Ball"],
  [
    "Zawodnicy truchtają wokół boiska z piłką przy nodze, zmieniając kierunek na sygnał trenera.",
    "Players jog around the pitch with the ball at their feet, changing direction on the coach's signal.",
  ],
  [
    "Utrzymuj piłkę blisko stopy, zmieniaj kierunek na sygnał.",
    "Keep the ball close to your foot and change direction on the signal.",
  ],
  ["Tempo swobodne, fokus na kontrolę piłki.", "Comfortable pace, focusing on ball control."],
  [
    "Prowadzenie piłki w wyznaczonych strefach, następnie wymiana podań w parach na krótkim dystansie.",
    "Players dribble the ball in designated areas, followed by short-distance passing in pairs.",
  ],
  ["Prowadzenie piłki + wymiana podań", "Dribbling + Passing"],
  [
    "Dwóch napastników atakuje jednego obrońcę i bramkarza. Nacisk na timing podania i wejście w przestrzeń.",
    "Two attackers attack one defender and the goalkeeper. Focus on pass timing and runs into space.",
  ],
  [
    "Napastnicy: timing podania. Obrońca: kąt ustawienia.",
    "Attackers: pass timing. Defender: body positioning angle.",
  ],
  [
    "Restart z linii środkowej po każdym zakończeniu akcji.",
    "Restart from the halfway line after each attack.",
  ],
  [
    "Posiadanie 4v2; po przejęciu szybkie przejście do ataku. Praca nad reagowaniem po stracie.",
    "4v2 possession game; after winning the ball, quickly transition into attack. Focus on reacting after losing possession.",
  ],
  ["Rotacja ról co 3–4 minuty.", "Rotate roles every 3–4 minutes."],
  ["Rotacja ról co 3-4 minuty.", "Rotate roles every 3–4 minutes."],
  [
    "Sekwencja ataków falowych z narastającą liczbą graczy. Cel: szybkie decyzje w przewadze.",
    "A sequence of wave attacks with an increasing number of players. Objective: quick decision-making in numerical superiority.",
  ],
  [
    "Ćwiczenie otwierania linii podań i ruchu bez piłki w sytuacji 2v1 przed polem karnym.",
    "Exercise focused on creating passing lanes and off-ball movement in a 2v1 situation in front of the penalty area.",
  ],
  [
    "Gra swobodna z naciskiem na tempo podań i utrzymanie rytmu.",
    "Free play with an emphasis on passing tempo and maintaining rhythm.",
  ],
  [
    "Statyczne rozciąganie + krótkie podsumowanie jednostek treningowych.",
    "Static stretching + a brief summary of the training session.",
  ],
  ["Fragment gry 4x2 z przejęciem piłki", "4v2 Possession Game with Transition"],
  ["Gra falowa od 2x1+Br do 3+Br x2", "Wave Game from 2v1 + GK to 3 + GK vs 2"],
  ["2x1 — tworzenie linii podań", "2v1 – Creating Passing Lanes"],
  ["2x1 + Bramkarz", "2v1 + Goalkeeper"],
  ["Podania na czas", "Timed Passing"],
  ["Pojemność fosfagenowa", "Phosphagen Capacity"],
  ["Trening na siłowni", "Gym training"],
  ["Mecz piłkarski", "Football match"],
  ["Treningi indywidualne", "Individual Training"],
  ["Trening personalny", "Individual Training"],
  ["Cykliczny trening siłowy — czwartki", "Recurring strength training — Thursdays"],
  ["Cykliczny trening — poniedziałki", "Recurring training — Mondays"],
  ["Cykliczny trening — wtorki", "Recurring training — Tuesdays"],
  ["Cykliczny trening — środy", "Recurring training — Wednesdays"],
  ["Cykliczny trening — czwartki", "Recurring Training — Thursdays"],
  ["Cykliczny trening — piątki", "Recurring training — Fridays"],
  ["Cykliczny trening — niedziele", "Recurring training — Sundays"],
  ["Cykliczne testy — co tydzień", "Recurring tests — weekly"],
  ["Cykliczny sparing — piątki", "Recurring friendly — Fridays"],
  ["Cykliczne zajęcia bramkarskie", "Recurring goalkeeper sessions"],
  ["Draft — trening techniczny", "Draft — technical training"],
  ["Draft — sparing kontrolny", "Draft — control friendly"],
  ["Draft — trening na siłowni", "Draft — gym session"],
  ["Draft — trening U14", "Draft — U14 training"],
  ["Cykliczny trening siłowy", "Recurring strength training"],
  ["Cykliczny trening", "Recurring training"],
  ["Cykliczne testy", "Recurring tests"],
  ["Cykliczny sparing", "Recurring friendly"],
  ["Trening techniczny", "Technical Training"],
  ["Trening taktyczny", "Tactical Training"],
  ["Trening piłkarski", "Football Training"],
  ["Grupa obserwowa", "Scouting Group"],
  ["Grupa obserwowana", "Scouting Group"],
  ["Grupa rezerwowa", "Reserve Group"],
  ["Oddział Akademii", "Academy Branch"],
  ["Pierwsza drużyna", "First Team"],
  ["Sekcja kobieca", "Women's Section"],
  ["Skrzat rezerwy", "Youth Reserves"],
  ["Puchar Wielkopolski", "Greater Poland Cup"],
  ["Mecz pucharowy", "Cup Match"],
  ["Sparing Kontrolny", "Friendly Match"],
  ["Sparing kontrolny", "Control Friendly"],
  ["Trening Trampkarz 2014", "2014 Youth Team Training"],
  ["Trening siłowy", "Strength Training"],
  ["Zajęcia bramkarskie", "Goalkeeper Session"],
  ["Turniej mini", "Mini Tournament"],
  ["Analiza wideo", "Video Analysis"],
  ["Testy okresowe", "Periodic Testing"],
  ["Klub piłkarski", "Football Club"],
  ["Grupa demo", "Demo Group"],
  ["Trampkarz 2014", "2014 Youth Team"],
  ["Trampkarz 2017", "2017 Youth Team"],
  ["Młodzik 2013", "2013 Youth Team"],
  ["Orlik 2014", "2014 Youth Team"],
  ["Skrzat 2015", "2015 Youth Team"],
  ["Boisko główne, Kraków", "Main Pitch, Kraków"],
  ["Boisko główne", "Main Pitch"],
  ["Boisko pomocnicze, Kraków", "Auxiliary Pitch, Kraków"],
  ["Boisko pomocnicze", "Auxiliary Pitch"],
  ["Hala sportowa, Kraków", "Sports Hall, Kraków"],
  ["Hala sportowa", "Sports Hall"],
  ["Sala treningowa, Kraków", "Training Hall, Kraków"],
  ["Sala treningowa", "Training Hall"],
  ["Sala konferencyjna, Warszawa", "Conference Room, Warsaw"],
  ["Sala konferencyjna", "Conference Room"],
  ["Stadion miejski, Kraków", "Municipal Stadium, Kraków"],
  ["Stadion Miejski, Kraków", "Municipal Stadium, Kraków"],
  ["Stadion miejski", "Municipal Stadium"],
  ["Boisko Warszawa", "Warsaw Pitch"],
  ["Hala Warszawa", "Warsaw Hall"],
  ["Siłownia Katowice", "Katowice Gym"],
  ["Orlik Katowice", "Orlik Pitch, Katowice"],
  ["ul. Sportowa 12, Kraków", "12 Sportowa St., Kraków"],
  ["al. Pokoju 44, Kraków", "44 Pokoju Ave., Kraków"],
  ["ul. Piłkarska 5, Warszawa", "5 Piłkarska St., Warsaw"],
  ["ul. Młodzieżowa 8, Katowice", "8 Młodzieżowa St., Katowice"],
  ["Opis demo wydarzenia „", "Demo event description: “"],
  [
    "”. Zapraszamy zawodników na zajęcia w ramach AcademyQ Demo.",
    "” Players are invited to attend a session as part of the AcademyQ Demo.",
  ],
  ["Odbiór piłki", "Ball Winning"],
  ["Część główna", "Main Part"],
  ["Koordynacyjne zdolności motoryczne (KZM)", "Coordination motor skills (CMS)"],
  ["Technika poruszania się", "Movement technique"],
  ["Głębia i szerokość ataku", "Depth and width of attack"],
  ["Ochrona przestrzeni", "Protecting space"],
  ["Zdobycie przestrzeni", "Gaining space"],
  ["Przyjęcie / podanie", "Receiving / Passing"],
  ["Zwody / drybling", "Feints / Dribbling"],
  ["Prowadzenie piłki", "Dribbling"],
  ["Kontrola piłki", "Ball control"],
  ["Moc fosfagenowa", "Phosphagen power"],
  ["Moc glikolityczna", "Glycolytic power"],
  ["Pojemność glikolityczna", "Glycolytic capacity"],
  ["Moc tlenowa", "Aerobic power"],
  ["Pojemność tlenowa", "Aerobic capacity"],
  ["Mecz towarzyski", "Friendly match"],
  ["Zakres testów", "Test scope"],
  ["Typ meczu", "Match type"],
  ["Wytrzymałość", "Endurance"],
  ["Powstrzymanie", "Stopping"],
  ["Asekuracja", "Covering"],
  ["Przestrzeń", "Space"],
  ["Mobilność", "Mobility"],
  ["Równowaga", "Balance"],
  ["Kompaktowość", "Compactness"],
  ["Regeneracja", "Recovery"],
  ["Podstawowy", "Basic"],
  ["Zwinność", "Agility"],
  ["Zwroty", "Turns"],
  ["Strzał", "Shot"],
  ["Sparing", "Friendly"],
  ["Siła", "Strength"],
  [
    "Nauczenie gry w ataku w sytuacji 2v2 przy otwarciu gry",
    "Teaching attacking play in a 2v2 situation during build-up play",
  ],
  ["Organizacja bloku defensywnego 4-4-2", "Organizing a 4-4-2 defensive block"],
  ["Dynamiczna mobilność + rondo 4v2", "Dynamic mobility + 4v2 rondo"],
  [
    "Przygotowanie do pracy w bloku — rytm, komunikacja, szybkie przejścia.",
    "Preparation for block work — rhythm, communication, quick transitions.",
  ],
  ["Przesuwanie linii w bloku", "Shifting the defensive line as a block"],
  [
    "Utrzymanie kompaktowości i przesuwanie bloku w zależności od strony piłki.",
    "Maintain compactness and shift the block depending on the ball side.",
  ],
  ["Pressing po stracie w strefie środkowej", "Pressing after losing the ball in midfield"],
  [
    "Natychmiastowa reakcja po stracie i domykanie linii podań.",
    "Immediate reaction after losing the ball and closing passing lanes.",
  ],
  ["Stretching + podsumowanie", "Stretching + recap"],
  [
    "Rozciąganie i krótkie wnioski z organizacji bloku.",
    "Stretching and a brief recap of the defensive block organization.",
  ],
  ["Gra bramkarza nogami — budowanie od tyłu", "Goalkeeper play with the feet — building from the back"],
  ["Technika przyjęcia i podania", "Receiving and passing technique"],
  [
    "Kontrola piłki pod presją i czyste pierwsze podanie.",
    "Ball control under pressure and a clean first pass.",
  ],
  ["Budowanie 3+1 pod pressingiem", "3+1 build-up under pressure"],
  [
    "Wybór linii podania i timing wyjścia poza pole karne.",
    "Choosing the passing lane and timing the exit outside the penalty area.",
  ],
  [
    "Utrzymuj otwarte biodra i wczesny kontakt wzrokowy z środkowym.",
    "Keep the hips open and make early eye contact with the centre-back.",
  ],
  [
    "Lekkie ćwiczenia mobilności i omówienie decyzji.",
    "Light mobility work and a review of the decisions.",
  ],
  ["Michał Nowak", "Michael Taylor"],
  ["Anna Kowalska", "Anna Smith"],
  ["Piotr Zieliński", "Peter Green"],
  [
    "Puchar Wielkopolski — mecz o stawkę na Stadionie Miejskim w Poznaniu. Skład 4-3-3, pełna dokumentacja dziennika meczu.",
    "Greater Poland Cup — competitive match at the Municipal Stadium in Poznań. 4-3-3 formation, complete match log documentation.",
  ],
  [
    "mecz o stawkę na Stadionie Miejskim w Poznaniu.",
    "competitive match at the Municipal Stadium in Poznań.",
  ],
  [
    "Skład 4-3-3, pełna dokumentacja dziennika meczu.",
    "4-3-3 formation, complete match log documentation.",
  ],
  ["Przerwanie gry — kontuzja rywala", "Play stopped — opponent injury"],
  ["Czas doliczony: +4 min", "Added time: +4 min"],
  ["Marek Górski", "Mark Hill"],
  ["Jakub Lis", "Jacob Fox"],
  ["Oskar Dąbrowski", "Oscar Davis"],
  ["Filip Mazur", "Philip Moore"],
  ["Szymon Wróbel", "Simon Brown"],
  ["Mateusz Król", "Matthew King"],
  ["Dominik Pawlak", "Dominic Parker"],
  ["Bartek Sikora", "Bart Parker"],
  ["Antoni Kamiński", "Anthony Carter"],
  ["Zuzanna Kwiatkowska", "Susan White"],
  ["Lena Tomaszewska", "Lena Thompson"],
  ["Maja Wróblewska", "Maya Walker"],
  ["Amelia Nowicka", "Amelia Newman"],
  ["Hanna Pietrzak", "Hannah Peterson"],
  ["Krzysztof Zieliński", "Christopher Green"],
  ["Nikodem Zieliński", "Nicholas Green"],
  ["Nikodem Wójcik", "Nicholas Walker"],
  ["Michał Zieliński", "Michael Green"],
  ["Piotr Wiśniewski", "Peter Wilson"],
  ["Łukasz Jasiński", "Luke Johnson"],
  ["Filip Jankowski", "Philip Jackson"],
  ["Kamil Jankowski", "Cameron Jackson"],
  ["Kacper Malinowski", "Casper Miller"],
  ["Grzegorz Michalski", "Greg Mitchell"],
  ["Alan Michalski", "Alan Mitchell"],
  ["Bartosz Krawczyk", "Bart Collins"],
  ["Szymon Dąbrowski", "Simon Davis"],
  ["Wiktor Czarnecki", "Victor Clark"],
  ["Wiktor Pawlak", "Victor Parker"],
  ["Damian Wróbel", "Daniel Brown"],
  ["Marek Lewandowski", "Mark Lewis"],
  ["Tomasz Kamiński", "Thomas Carter"],
  ["Tomasz Lewandowski", "Thomas Lewis"],
  ["Dominik Król", "Dominic King"],
  ["Artur Sobczak", "Arthur Scott"],
  ["Fabian Tomczyk", "Fabian Thomas"],
  ["Patryk Góra", "Patrick Young"],
  ["Robert Górski", "Robert Hill"],
  ["Oskar Mazur", "Oscar Moore"],
  ["Mateusz Lis", "Matthew Fox"],
  ["Igor Szymański", "Igor Smith"],
  ["Natalia Baran", "Natalie Baker"],
  ["Oliwia Sikora", "Olivia Parker"],
  ["Jan Kowalski", "John Smith"],
  ["Adam Nowak", "Adam Taylor"],
  ["Cele motoryczne", "Physical Objectives"],
  ["Cele energetyczne", "Energy System Objectives"],
  ["Cele techniczne", "Technical Objectives"],
  ["Zasady gry", "Game Rules"],
  ["Rozszerzony", "Extended"],
  ["Indywidualne", "Individual"],
  ["Pierwsza drużyna — rezerwa", "First Team — Reserve"],
  ["Pierwsza drużyna - rezerwa", "First Team - Reserve"],
  ["U16 Liga", "U16 League"],
  ["Olivier Bąk", "Oliver Baker"],
  ["Marcin Ostrowski", "Martin Foster"],
  ["Trampkarz", "Youth Team"],
  ["Młodzik", "U13 Team"],
  ["Smyki", "Mini Kickers"],
  ["Rezerwy", "Reserves"],
  ["Rozwój w akademii", "Academy Development"],
  ["Praca w pressingu", "Pressing"],
  ["praca w pressing-u", "Pressing"],
  ["praca w pressingu", "Pressing"],
  ["Szybkość", "Speed"],
  ["Wsparcie", "Support"],
  ["Rozciąganie", "Stretching"],
  ["Rozgrzewka", "Warm-up"],
  ["Schłodzenie", "Cool-down"],
  ["Gra końcowa", "Final Game"],
  ["Płatność", "Payment"],
  [
    "Współpracuje z akademią od 2024 roku.",
    "Has been cooperating with the academy since 2024.",
  ],
  [
    "Demo akademia sportowa — treningi, składy i sklep klubowy w jednym miejscu.",
    "Demo sports academy — training, squads and club shop in one place.",
  ],
  ["Sprzedaż karnetów i odzieży klubowej", "Sale of passes and club apparel"],
  ["Licencja ", "License "],
  [" grupy ", " of "],
  ["Piłka nożna", "Football"],
  ["Menager", "Manager"],
  ["Analityk", "Analyst"],
  ["Trener", "Coach"],
  ["Skaut", "Scout"],
  [
    "Dobry mecz — aktywny w pressingu, czyste przyjęcia i kilka kluczowych podań w budowaniu akcji.",
    "A good performance — active in pressing, clean first touches and several key passes in build-up play.",
  ],
  [
    "Solidna dyspozycja defensywna. Warto jeszcze poprawić timing wyjść do pressingu.",
    "Solid defensive performance. The timing of pressing actions could still be improved.",
  ],
  [
    "Bardzo dobra dynamika w ataku. Gol i asysta — największy wpływ na wynik.",
    "Very good attacking dynamism. A goal and an assist — the biggest impact on the result.",
  ],
  [
    "Spokojna gra nogami, dobre decyzje pod pressingiem. Do poprawy komunikacja.",
    "Composed play with the ball at his feet and good decision-making under pressure. Communication could be improved.",
  ],
  ["Solidna dyspozycja defensywna.", "Solid defensive performance."],
  [
    "Warto jeszcze poprawić timing wyjść do pressingu.",
    "The timing of pressing actions could still be improved.",
  ],
  [
    "Spokojna gra nogami, dobre decyzje pod pressingiem.",
    "Composed play with the ball at his feet and good decision-making under pressure.",
  ],
  ["Do poprawy komunikacja.", "Communication could be improved."],
  ["Bardzo dobra dynamika w ataku.", "Very good attacking dynamism."],
  [
    "Gol i asysta — największy wpływ na wynik.",
    "A goal and an assist — the biggest impact on the result.",
  ],
  [
    "Przydatny z ławki — szybko wszedł w rytm i utrzymał tempo w końcówce.",
    "Useful off the bench — quickly found the rhythm and kept the tempo late on.",
  ],
  [
    "Spokojna dyspozycja między słupkami. Pewne interwencje, dobre wyprowadzenie piłki — jedna stracona przy końcówce.",
    "Composed between the posts. Confident saves, good distribution — one goal conceded late on.",
  ],
  [
    "Solidna praca na lewej flance. Dobrze zamykał stronę i wspierał atak.",
    "Solid work on the left flank. Closed the side well and supported the attack.",
  ],
  [
    "Dobra pierwsza połowa, ale druga żółta i czerwona kartka zmieniły układ. Lekcja koncentracji.",
    "Good first half, but a second yellow and a red card changed the setup. A lesson in concentration.",
  ],
  [
    "Kompaktowa gra w środku obrony. Żółta kartka za spóźniony wślizg — poza tym pewny.",
    "Compact in central defence. A yellow card for a late tackle — otherwise assured.",
  ],
  [
    "Aktywny do 75'. Po zmianie rytm drużyny się utrzymał — dobra dyspozycja.",
    "Active until the 75th minute. After the substitution the team's rhythm held — a good performance.",
  ],
  [
    "Dużo kilometrów w środku pola. Żółta kartka, ale wciąż kluczowy w pressingu.",
    "Covered a lot of ground in midfield. A yellow card, but still key in the press.",
  ],
  [
    "Najlepszy dyrygent środka — tempo podań, odbiór i przejścia do ataku.",
    "The best midfield conductor — passing tempo, ball winning and transitions into attack.",
  ],
  [
    "Solidny do zejścia. Po zmianie widać było spadek dynamiki na prawej stronie.",
    "Solid until coming off. After the change the right side lost some dynamism.",
  ],
  [
    "Gol i dużo zagrożenia z lewej. Zejście w drugiej połowie po dużym nakładzie sił.",
    "A goal and a lot of threat from the left. Came off in the second half after a high workload.",
  ],
  [
    "Otworzył wynik i cały czas szukał głębi. Największy wpływ na wynik meczu.",
    "Opened the scoring and constantly looked to run in behind. The biggest impact on the result.",
  ],
  [
    "Gol w drugiej połowie i dobra praca bez piłki. Bardzo dobra dyspozycja skrzydła.",
    "A second-half goal and good off-the-ball work. A very good performance from the winger.",
  ],
  [
    "Wejście z ławki — szybko złapał rytm i ustabilizował środek pola.",
    "Came on from the bench — quickly found the rhythm and stabilised midfield.",
  ],
  [
    "Świeżość po zmianie. Kilka groźnych dośrodkowań i utrzymanie tempa ataku.",
    "Freshness after coming on. Several dangerous crosses and kept the attacking tempo.",
  ],
  [
    "Wzmocnienie obrony po czerwonej. Spokojne decyzje i dobre ustawianie.",
    "Reinforced the defence after the red card. Calm decisions and good positioning.",
  ],
  [
    "Sugestia AI (demo): dobra dyspozycja, warto utrzymać intensywność pressingu.",
    "AI suggestion (demo): good performance, keep the pressing intensity.",
  ],
];

DEMO_PL_TO_EN.sort((a, b) => b[0].length - a[0].length);

/** Split name fields used in statistics / monitoring (not full "Jan Kowalski"). */
const DEMO_FIRST_NAMES: Record<string, string> = {
  Jan: "John",
  Adam: "Adam",
  Olivier: "Oliver",
  Marcin: "Martin",
  Piotr: "Peter",
  Kacper: "Casper",
  Bartosz: "Bart",
  Tomasz: "Thomas",
  Marek: "Mark",
  Łukasz: "Luke",
  Filip: "Philip",
  Oskar: "Oscar",
  Michał: "Michael",
  Dominik: "Dominic",
  Natalia: "Natalie",
  Zuzanna: "Susan",
  Oliwia: "Olivia",
  Lena: "Lena",
  Maja: "Maya",
  Amelia: "Amelia",
  Hanna: "Hannah",
  Krzysztof: "Christopher",
  Nikodem: "Nicholas",
  Igor: "Igor",
  Artur: "Arthur",
  Alan: "Alan",
  Robert: "Robert",
  Damian: "Daniel",
  Mateusz: "Matthew",
  Wiktor: "Victor",
  Szymon: "Simon",
  Patryk: "Patrick",
  Fabian: "Fabian",
  Grzegorz: "Greg",
  Kamil: "Cameron",
  Jakub: "Jacob",
  Bartek: "Bart",
  Antoni: "Anthony",
  Anna: "Anna",
};

const DEMO_LAST_NAMES: Record<string, string> = {
  Kowalski: "Smith",
  Nowak: "Taylor",
  Wiśniewski: "Wilson",
  Malinowski: "Miller",
  Krawczyk: "Collins",
  Lewandowski: "Lewis",
  Kamiński: "Carter",
  Zieliński: "Green",
  Jasiński: "Johnson",
  Jankowski: "Jackson",
  Mazur: "Moore",
  Wójcik: "Walker",
  Szymański: "Smith",
  Michalski: "Mitchell",
  Król: "King",
  Sobczak: "Scott",
  Wróbel: "Brown",
  Górski: "Hill",
  Lis: "Fox",
  Pawlak: "Parker",
  Dąbrowski: "Davis",
  Góra: "Young",
  Tomczyk: "Thomas",
  Kwiatkowska: "White",
  Baran: "Baker",
  Sikora: "Parker",
  Tomaszewska: "Thompson",
  Wróblewska: "Walker",
  Nowicka: "Newman",
  Pietrzak: "Peterson",
  Czarnecki: "Clark",
  Bąk: "Baker",
  Ostrowski: "Foster",
};

export const isDemoEnglish = () => {
  const fromI18n = (
    i18n.language ||
    (i18n as { resolvedLanguage?: string }).resolvedLanguage ||
    ""
  ).toLowerCase();

  if (fromI18n.startsWith("en")) return true;
  if (fromI18n.startsWith("pl")) return false;

  try {
    const stored = (localStorage.getItem(LANGUAGE_STORAGE_KEY) || "").toLowerCase();
    return stored.startsWith("en");
  } catch {
    return false;
  }
};
export const localizeDemoString = (value: string): string => {
  if (!isDemoEnglish() || !value) return value;
  let result = value;
  for (const [pl, en] of DEMO_PL_TO_EN) {
    if (result.includes(pl)) result = result.split(pl).join(en);
  }
  return result;
};

export const matchesDemoSearch = (value: string, search: string): boolean => {
  if (!search) return true;
  const query = search.toLowerCase();
  if ((value || "").toLowerCase().includes(query)) return true;
  return localizeDemoString(value || "").toLowerCase().includes(query);
};

const cloneDemoValue = <T>(value: T): T => {
  if (typeof structuredClone === "function") {
    try {
      return structuredClone(value);
    } catch {
      /* fallback below */
    }
  }
  return JSON.parse(JSON.stringify(value)) as T;
};

const localizeNameField = (key: string, value: string): string => {
  if (key === "FirstName" || key === "firstName") {
    return DEMO_FIRST_NAMES[value] ?? localizeDemoString(value);
  }
  if (key === "LastName" || key === "lastName") {
    return DEMO_LAST_NAMES[value] ?? localizeDemoString(value);
  }
  return localizeDemoString(value);
};

export const localizeDemoDeep = <T>(value: T, parentKey?: string): T => {
  if (!isDemoEnglish() || value == null) return value;

  if (typeof value === "string") {
    return (parentKey ? localizeNameField(parentKey, value) : localizeDemoString(value)) as T;
  }
  if (typeof value !== "object") return value;
  if (value instanceof Date) return value;

  if (Array.isArray(value)) {
    return value.map((item) => localizeDemoDeep(item)) as T;
  }

  const input = value as Record<string, unknown>;
  const output: Record<string, unknown> = {};
  for (const key of Object.keys(input)) {
    output[key] = localizeDemoDeep(input[key], key);
  }
  return output as T;
};

/** Clone (when EN) + localize nested demo strings. Safe for cached mock arrays. */
export const asDemoLocale = <T>(value: T): T => {
  if (!isDemoEnglish() || value == null) return value;
  return localizeDemoDeep(cloneDemoValue(value));
};

/** Wrap a mock getter so its return value is localized for the active UI language. */
export const demoApi = <A extends any[], R>(fn: (...args: A) => R) => {
  return ((...args: A) => {
    const result = fn(...args) as R | Promise<unknown>;
    if (result != null && typeof (result as { then?: unknown }).then === "function") {
      return (result as Promise<unknown>).then((value) => asDemoLocale(value));
    }
    return asDemoLocale(result as R);
  }) as (...args: A) => R;
};
